import React,{useEffect} from 'react'
import styles from './FluIndices.module.scss'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import GeoProvider from '../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from './dataDisplayOptions'
import { startDate, endDate, displayDate } from './dates'
import Header from './Header'
import Gender from '../GenderAge'
import SeasonalPattern from '../SeasonalPattern'
import { useLocation } from "react-router-dom"
import SystemNotification from './../Dashboard/SystemNotification'
import BelowMapNotification from '../Dashboard/BelowMapNotification'
const FluDashboard = () => {
  var getRegionType = 'metro'
  const location = useLocation()
  const hash = location.hash
  if (hash) {
    if (hash.length > 1 && hash === '#zip3') {
      getRegionType = 'zip3'
    }
  }
    
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={getRegionType}
            >
              <SystemNotification/>
              <Header headerType="nat" headerNumber={1} />
              <DashboardMap />
              <BelowMapNotification message_type='WEEKLY'/>
              <Gender geo_type="nat" geo_id="nat" data_type="flu" />
              <SeasonalPattern geo_type="nat" geo_id="nat" data_type="flu" />
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default FluDashboard
